import React, { useState, useEffect, useRef } from 'react'
import { searchIcon, darkModeIcon, lighModeIcon } from '../assets/images'
import { useDispatch, useSelector } from 'react-redux'
import { toggleDarkMode, switchStyle } from '../redux/mapStyleSlice'

const SearchBar = ({
  handlePlaceSelect,
  geocodingClient,
  setDropdownOpen,
  dropdownOpen,
  selectedPlace
}) => {
  const [inputValue, setInputValue] = useState('')
  const [places, setPlaces] = useState([])
  const [isInputFocused, setIsInputFocused] = useState(false)
  const wrapperRef = useRef(null)
  const dispatch = useDispatch()
  const theme = useSelector((state) =>
    state.mapStyle.darkMode ? 'dark' : 'light'
  )

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])
  const handleStyleChange = () => {
    dispatch(toggleDarkMode())
    dispatch(switchStyle())
  }
  const handleInputChange = async (event) => {
    setInputValue(event.target.value)
    setDropdownOpen(true)

    const response = await geocodingClient
      .forwardGeocode({
        query: inputValue,
        limit: 5
      })
      .send()

    setPlaces(response.body.features)
  }

  return (
    <div ref={wrapperRef} className='sm:w-3/6 flex items-center'>
      <div
        className={`sm:-mt-8 mt-4 w-full border-2 rounded-full shadow appearance-none focus-within:outline-none focus-within:shadow-outline flex items-center px-3 justify-between ${
          theme === 'light'
            ? 'bg-white border-zinc-300'
            : 'bg-[#353535] border-zinc-700'
        }`}
      >
        <div className='flex items-center w-full'>
          <img src={searchIcon} alt='icono de busqueda' />
          <input
            className={`w-full sm:text-sm py-2 ml-4 text-xs leading-tight text-gray-300  placeholder-gray-400 focus:outline-none ${
              theme === 'light'
                ? 'bg-white border-zinc-300'
                : 'bg-[#353535] border-zinc-700'
            }`}
            type='text'
            id='search'
            value={inputValue}
            onChange={handleInputChange}
            placeholder={
              isInputFocused ? '' : 'Search by location or place ...'
            }
            onFocus={() => setIsInputFocused(true)}
            onBlur={() => setIsInputFocused(false)}
          />
        </div>
        <div className='ml-2'>
          <img
            src={theme === 'light' ? darkModeIcon : lighModeIcon}
            alt='icon change color'
            onClick={handleStyleChange}
          />
        </div>
      </div>
      <div
        className={`${
          dropdownOpen && !selectedPlace ? '' : 'hidden'
        } absolute top-full left-1/2 transform -translate-x-1/2 rounded-lg mt-1 bg-gray-800 text-white`}
      >
        {places.map((place) => (
          <div
            key={place.id}
            onClick={() => handlePlaceSelect(place)}
            className='px-3 py-2 cursor-pointer hover:bg-gray-700 hover:bg-opacity-60'
          >
            {place.place_name}
          </div>
        ))}
      </div>
    </div>
  )
}

export default SearchBar
